// extracted by mini-css-extract-plugin
export default {"ModalButton":"ModalButton_ModalButton__pp3ZS","Disabled":"ModalButton_Disabled__WzMoh"};